import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'
//加载路由数据使用
import menuData from "./menuData";
//引入消息组件
import {Message} from "element-ui";

Vue.use(VueRouter)

//路由项
const router = new VueRouter(initRouterOption(welcomePage(store.getters['sys/getRouters']||[])))
// console.log("路由初始化！！！！！！！！！")
//解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


//前置路由守卫，
router.beforeEach(async (to, from, next) => {
  // console.log("进入路由》》", to)
  if (to.path=='/login' || to.path=='/notFound' || to.path.startsWith('/txdcwj/') ) {

    //清除store
    // store.commit('sys/CLEAR_ALL');
    return next()
  }
  // 未登录
  if(!store.state.sys.loginUser){
    Message.error('登录超时，请重新登录');
    //清除store
    store.commit('sys/CLEAR_ALL');
    return next("/login")
  }
  // console.log('@options@>>>>>>>>>>>',router.options)
  // console.log("需要权限")
  //测试动态添加路由,没有子路由，读取子路由
  if (!store.getters['sys/getRouters'].length) {
    // console.log('设置动态路由')
    //数据库中加载数据
    let dynamicRoutes= await menuData.getDataList();
    //store获取数据
    // console.log('获取store数据》》',newVar);
    if (dynamicRoutes.length) {
      //动态内容追加进去
      const temp_welcome=welcomePage();//注意此处的写法，将一个对象的值赋给另一个对象，而不是赋给它的引用
      temp_welcome.children=dynamicRoutes;
      temp_welcome.children.push(
        {
          name: 'Welcome1',
          path: '/Welcome1',
          component: () => import('../views/Welcome1.vue'),
          meta:{
            title:'',
            isAuth:false
          }
        }
      );
      //重置路由  解决警告问题
      router.matcher = new VueRouter(initRouterOption()).matcher
      router.addRoute(temp_welcome)
      //刷新路由后，next需要指定跳转位置
      return next({...to})
      // return next()
    } else {
      // console.log("err")
      Message.error('未授权，请联系管理员！');
      //清除store
      store.commit('sys/CLEAR_ALL');
      return next("/login")
    }
  }else{
    // console.log("有路由》》",router)
  }
  // console.log(to)
  // 设置操作按钮权限
  store.commit('sys/SET_CZBTNS',to.meta.czbtns);
  return next();
})
//后置守卫
router.afterEach((to,from)=>{
  // document.title=to.meta.title||'管理系统';
})
//初始化配置项
function initRouterOption(addWelcomPage){
  //注意此处json,否则会是对象额引用，而不是创建一个新对象
  let routes=baseRoute();
  if(addWelcomPage){
    routes.push(addWelcomPage);
  }

  const router_option={
    mode: 'history',
    base: '/gsyf/',
    routes
  }
  // console.log('整合路由》》',router_option)
  return router_option
}
//初始化基础路径
function baseRoute(){
  return [
    {
      path: '/',
      redirect: '/login',//重定向
    },
    {
      path: '/notFound',
      name: 'NotFound',
      meta: {
        title: 'Page not found',
        isLogin: false
      },
      component: () => import('@/views/NotFound')
    },
    // 所有未定义路由，全部重定向到404页
    {
      path: '*',
      redirect: '/notFound'
    },
    {
      name: 'Login',
      path: '/login',
      component: () => import('../views/Login'),
      meta:{
        title:'登陆',
        isAuth:false
      }
    },
    {
      name: 'TxDcwj',
      path: '/txdcwj/:id',
      component: () => import('../views/dcwj/plan/TxDcwj.vue'),
      meta:{
        title:'调查问卷',
        isAuth:false
      }
    }
  ]
}
//  布局页，欢迎页
function welcomePage(children){
  return {
    path: '/welcome',/*布局页*/
    name: 'Welcome',
    component:() => import('../views/Welcome'),
    meta: {
      title: '首页',
      isTabsPage: true,
      isAuth: true
    },
    children:  children||[]
  }
}
//暴露数据
export default  router;



// WEBPACK FOOTER //
// ./src/router/index.js